import { fetchAuthSession } from "@aws-amplify/auth";
import axios from "axios";

const withAuthHeaders = async (config = {}) => {
  const session = await fetchAuthSession({
    forceRefresh: true,
  });
  const userToken = session.tokens?.idToken?.toString();

  return {
    ...config,
    headers: {
      ...(config.headers || {}),
      ...(userToken ? { Authorization: userToken } : {}),
    },
  };
};

export const eventApi = {
  get: async (url, config) => axios.get(url, await withAuthHeaders(config)),
  post: async (url, data, config) =>
    axios.post(url, data, await withAuthHeaders(config)),
  put: async (url, data, config) =>
    axios.put(url, data, await withAuthHeaders(config)),
  delete: async (url, data, config) => {
    const authConfig = await withAuthHeaders(config);

    return axios({
      ...authConfig,
      method: "delete",
      url,
      data,
      headers: {
        "Content-Type": "application/json",
        ...(authConfig.headers || {}),
      },
    });
  },
};
